export class Denounced {
    get id() {
        return this.denouncedState.id;
    }
    get diligenceNumber() {
        return this.denouncedState.diligenceNumber;
    }
    get denouncedThirId() {
        return this.denouncedState.denouncedThirId;
    }
    get manifestation() {
        return this.denouncedState.manifestation;
    }
    get dateCreated() {
        return this.denouncedState.dateCreated;
    }
    get collegiate() {
        return this.denouncedState.collegiate;
    }
    get present() {
        return this.denouncedState.present;
    }
    get delivery() {
        return this.denouncedState.delivery;
    }
    get userId() {
        return this.denouncedState.userId;
    }
    get representativeThirdId() {
        return this.denouncedState.representativeThirdId;
    }
    get third_name() {
        return this.denouncedState.third_name;
    }
    set diligenceNumber(diligenceNumber) {
        this.denouncedState.diligenceNumber = diligenceNumber;
    }
    set denouncedThirId(denouncedThirId) {
        this.denouncedState.denouncedThirId = denouncedThirId;
    }
    set manifestation(manifestation) {
        this.denouncedState.manifestation = manifestation;
    }
    set dateCreated(dateCreated) {
        this.denouncedState.dateCreated = dateCreated;
    }
    set collegiate(collegiate) {
        this.denouncedState.collegiate = collegiate;
    }
    set present(present) {
        this.denouncedState.present = present;
    }
    set userId(userId) {
        this.denouncedState.userId = userId;
    }
    set representativeThirdId(representativeThirdId) {
        this.denouncedState.representativeThirdId = representativeThirdId;
    }
    set third_name(thirdName) {
        this.denouncedState.third_name = thirdName;
    }
    constructor(denouncedState) {
        this.denouncedState = denouncedState;
    }
    getState() {
        return this.denouncedState;
    }
}
